<template>
    <div>
        <div>
            <el-form :model="$parentInfo.dialog_UpdateEmployee.employee" :label-position="'right'" label-width="80px" >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="姓名">
                            <el-input v-model="$parentInfo.dialog_UpdateEmployee.employee.name"
                                      placeholder="请输入姓名"
                                      style="width:200px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="电话">
                            <el-input v-model="$parentInfo.dialog_UpdateEmployee.employee.phone"
                                      placeholder="无电话"
                                      style="width: 200px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="新增角色">
                            <el-select v-model="$parentInfo.dialog_UpdateEmployee.employee.new_role"
                                       placeholder="请选择"
                                       multiple
                                       clearable
                                       style="width: 200px">
                                <el-option
                                        v-for="item in $parentInfo.dialog_UpdateEmployee.roles"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态">
                            <el-select v-model="$parentInfo.dialog_UpdateEmployee.employee.status"
                                       placeholder="请选择"
                                       style="width: 200px">
                                <el-option
                                        v-for="item in $parentInfo.dialog_UpdateEmployee.status_type"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleUpdateEmployee"
                       :loading="$parentInfo.dialog_UpdateEmployee.button_loading">修 改
            </el-button>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Dialog_UpdateEmployee",
        data () {
            return {
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShow();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleShow(){
                this.$parentInfo.dialog_UpdateEmployee.employee.id=this.$store.state.modal.data.employee.id;
                this.$parentInfo.dialog_UpdateEmployee.employee.name=this.$store.state.modal.data.employee.name;
                this.$parentInfo.dialog_UpdateEmployee.employee.phone=this.$store.state.modal.data.employee.phone;
                this.$parentInfo.dialog_UpdateEmployee.employee.status=this.$store.state.modal.data.employee.status;
            },
            handleUpdateEmployee(){
                this.$parentInfo.dialog_UpdateEmployee.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'update_employee_msg', {
                    'employee': this.$parentInfo.dialog_UpdateEmployee.employee,
                });
            }
        }
    }
</script>

<style scoped>

</style>